import { AfterViewInit, Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import 'jquery-slimscroll';
import { IdentityService } from 'app/views/appviews/security/identity.service';
import { SecurityService } from 'app/shared/services/security.service';

declare var jQuery: any;

@Component({
  selector: 'navigation',
  templateUrl: 'navigation.template.html'
})

export class NavigationComponent implements OnInit, AfterViewInit{
  constructor(private router: Router
    , public access: IdentityService
    , public securityService: SecurityService) {

    }
    ngOnInit() {
      this.access.loadUserData().then(() => {
      }).catch(error => {
        console.error('Error al cargar datos del usuario:', error);
      });
    }

  ngAfterViewInit() {
    jQuery('#side-menu').metisMenu();

    if (jQuery("body").hasClass('fixed-sidebar')) {
      jQuery('.sidebar-collapse').slimscroll({
        height: '100%'
      })
    }
  }
  activeRoute(routename: string): boolean{
    return this.router.url.indexOf(routename) > -1;
  }
}
